import { IPage } from "@common/models/CMS/Page";
import { IGResponse } from "@common/models/Response";
import { getFilePath } from "@config/appConfig";
import { GET_PAGE, useApolloQuery } from "@service/graphql";
import Translate from "@service/Translate";
import { FC, Fragment } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router";

interface IPageMeta {
    title?: string;
    cover?: string;
    description?: string;
}

export const PageMeta: FC<IPageMeta> = ({ children, title, description, cover }) => {
    const { tr } = Translate;
    const { pathname } = useLocation();
    const { data } = useApolloQuery<IGResponse<IPage[]>>(GET_PAGE, { variables: { code: pathname === "/" ? "home" : pathname?.substring(1) } });
    const page = data?.page[0];

    return (
        <Fragment>
            <Helmet>
                <title>{title || page?.title ? `${title || page?.title} | ${tr("mahan_air")}` : tr("mahan_air")}</title>
                <meta name="description" content={description || page?.description || tr("mahan_air_web_site")} />
                {/* iOS pin to home screen */}
                <meta name="mobile-web-app-capable" content="yes" />
                <meta name="apple-mobile-web-app-title" content="Mahan Air" />
                <meta name="apple-mobile-web-app-capable" content="yes" />
                <meta name="apple-mobile-web-app-status-bar-style" content="white" />
                {/*  Windows pin to start*/}
                <meta name="application-name" content="Mahan Air" />
                <meta name="msapplication-TileColor" content="white" />
                <meta name="msapplication-TileImage" content={`${process.env.PUBLIC_URL}/favicon/ms-icon-144x144.png`} />
                <meta name="msapplication-config" content="none" />
                <meta name="msapplication-tooltip" content="Mahan Air Website" />
                <meta name="msapplication-square150x150logo" content={`${process.env.PUBLIC_URL}/favicon/ms-icon-150x150.png`} />
                <meta name="msapplication-square310x310logo" content={`${process.env.PUBLIC_URL}/favicon/ms-icon-310x310.png`} />
                <meta name="msapplication-square70x70logo" content={`${process.env.PUBLIC_URL}/favicon/ms-icon-70x70.png`} />
                <meta name="msapplication-wide310x150logo" content={`${process.env.PUBLIC_URL}/favicon/ms-icon-310x150.png`} />
                {/* <!-- Chromium theme color --> */}
                <meta name="theme-color" content="#00a693" />
                <meta property="og:site_name" content={tr("mahan_air")} />
                <meta property="og:local" content={"fa_IR"} />
                <meta property="og:title" content={title || page?.title} />
                <meta property="og:description" content={description || page?.description || tr("mahan_air_web_site")} />
                <meta property="og:image" content={getFilePath(cover || page?.cover?.paths[0])} />
                {page?.relatedPages?.contentItems.map((item, index) => <meta key={index} property="og:see_also" content={`${window.location.host}/${item.code?.code}`} />)}
                <meta property="og:image:width" content="300" />
                <meta property="og:image:height" content="300" />
                {/* Description & link twitter */}
                <meta name="twitter:title" content={title || page?.title} />
                <meta name="twitter:card" content="summery_image" />
                <meta name="twitter:description" content={description || page?.description || tr("mahan_air_web_site")} />
                <meta name="twitter:site" content={tr("mahan_air")} />
                <meta name="twitter:image:src" content={getFilePath(cover || page?.cover?.paths[0])} />
            </Helmet>
            {children}
        </Fragment>
    )
}